import React from 'react';
import { Box } from 'pounceV2';
import NotificationsSettingsV3 from './NotificationsSettingsV3';
import NotificationsV3 from './NotificationsV3';

const NotificationsContainerV3 = () => {
  const [displaySettings, setDisplaySettings] = React.useState<boolean>(false);

  return (
    <Box height="100%">
      {displaySettings ? (
        <NotificationsSettingsV3 onToggleSettings={setDisplaySettings} />
      ) : (
        <NotificationsV3 onToggleSettings={setDisplaySettings} />
      )}
    </Box>
  );
};

export default NotificationsContainerV3;
